const graphqlFilterOperatorAliases = {
  eq: ['eq', 'equals', 'equal', 'is'],
  ne: ['ne', 'neq', 'noteq', 'notequals', 'notEqual', 'not_equals'],
  gt: ['gt', 'greaterthan', 'greater_than'],
  lt: ['lt', 'lessthan', 'less_than'],
  gte: ['gte', 'ge', 'greaterthanorequal', 'greater_than_or_equal', 'greaterthanorequals', 'greater_than_or_equals'],
  lte: ['lte', 'le', 'lessthanorequal', 'less_than_or_equal', 'lessthanorequals', 'less_than_or_equals'],
  contain: ['contain', 'contains', 'like', 'ilike', 'match', 'matches'],
  ncontain: ['ncontain', 'notcontain', 'notcontains', 'not_contain', 'not_contains', 'nlike', 'nilike', 'notlike', 'not_like', 'notilike', 'not_ilike'],
  between: ['between'],
  exist: ['exist', 'exists'],
  nexist: ['nexist', 'notexist', 'notexists', 'not_exist', 'not_exists'],
  empty: ['empty', 'isempty', 'is_empty'],
  nempty: ['nempty', 'notempty', 'not_empty', 'isnotempty', 'is_not_empty']
};

export default graphqlFilterOperatorAliases;
